// Use these values

// eslint-disable-next-line import/prefer-default-export
export var sizes = ["none", "xs", "sm", "md", "lg", "xl", "xxl"];